<template>
    <ContainerContent
        class="mb-16 mt-4"
        max-class="max-w-sm-ceil"
        outer-container
    >
        <v-row>
            <v-col cols="12" md="6" offset-md="3">
                <h1 class="page-title">Start a Return</h1>
                <p class="mb-2">
                    Enter your order number and the email address used on the
                    order to begin a return. You'll be able to choose the items
                    you'd like to send back and get a prepaid shipping label.
                </p>
                <p class="text-medium-emphasis">
                    Your order number is in your order confirmation email. Logged
                    in?
                    <NuxtLink to="/account/orders">View your orders</NuxtLink>.
                </p>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6" offset-md="3">
                <OrderStatusForm
                    :form-values="lookupParams || undefined"
                    submit-label="Find My Order"
                    @on-status="onStatus($event)"
                ></OrderStatusForm>
            </v-col>
        </v-row>
    </ContainerContent>
</template>

<script lang="ts" setup>
    import type { OrderStatus, OrderStatusResponse } from '~/types';
    import OrderStatusForm from '~/components/orders/OrderStatusForm/OrderStatusForm.vue';
    import ContainerContent from '~/components/ContainerContent/ContainerContent.vue';
    import { isError as lo_isError } from 'es-toolkit';
    import { useGlobalAlert } from 'x1-base/composables';

    definePageMeta({
        scrollToTop: true
    });

    const $config = useRuntimeConfig();
    const brandTitle = $config.public.brand.title;
    const route = useRoute();
    const createGlobalAlert = useGlobalAlert();

    const lookupParams = ref<Partial<OrderStatus>>(route.query as Partial<OrderStatus>);

    async function onStatus(response: OrderStatusResponse | Error): Promise<void> {
        if (lo_isError(response)) {
            createGlobalAlert({
                text: 'Could not find an order with the values you entered. Please try again or contact customer service.',
                show: true,
                type: 'error'
            });

            return;
        }

        // Success: continue into the return form for this order
        await navigateTo(`/return/${response.uid}`);
    }

    useHead({
        title: `Start a Return | ${brandTitle}`,
        meta: [
            {
                name: 'description',
                content: 'Start a return for your order.'
            }
        ]
    });
</script>

<style lang="scss" scoped></style>
